import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMessage = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.333 2.645c-.707 0-1.385.278-1.885.774a2.634 2.634 0 0 0-.781 1.87v13.998l3.057-3.032c.25-.248.589-.387.943-.387h12c.707 0 1.385-.279 1.885-.775s.781-1.168.781-1.87V5.29c0-.701-.28-1.374-.78-1.87a2.678 2.678 0 0 0-1.886-.774H5.333Zm-3.77-1.096A5.349 5.349 0 0 1 5.332 0h13.334a5.35 5.35 0 0 1 3.77 1.55A5.267 5.267 0 0 1 24 5.29v7.933a5.267 5.267 0 0 1-1.562 3.74 5.356 5.356 0 0 1-3.771 1.55H7.219l-4.943 4.901a1.341 1.341 0 0 1-1.453.287A1.322 1.322 0 0 1 0 22.48V5.29a5.26 5.26 0 0 1 1.562-3.74Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.333 6.612c0-.73.597-1.323 1.334-1.323h10.666c.737 0 1.334.592 1.334 1.323 0 .73-.597 1.322-1.334 1.322H6.667a1.328 1.328 0 0 1-1.334-1.322Zm0 5.288c0-.73.597-1.321 1.334-1.321h8c.736 0 1.333.592 1.333 1.322 0 .73-.597 1.322-1.333 1.322h-8a1.328 1.328 0 0 1-1.334-1.322Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMessage);
export default ForwardRef;
